export default "__VITE_ASSET__CK$o5usS__"